import React, { Component } from 'react';

import { TimedLowerAndUpperLimitRules } from './generic/TimedLowerAndUpperLimitRules';

export class HoneyCombFareRules extends Component {
    constructor(props) {
        super(props);

        this.state = {
            model: this.props.model,
            priceInputError: null
        };
    }

    // ----------------------

    render() {
        const { model } = this.state;

        if (null === model || undefined === model) {
            return null;
        }

        const { isEditable } = this.props;

        if (Array.isArray(model.rules)) {
            model.rules.sort((a, b) => a.lowerLimit - b.lowerLimit);
        }

        return (
            <TimedLowerAndUpperLimitRules
                model={model}
                isEditable={isEditable}
                description="Favos"
                limitUnit="Zonas"
                timeUnit="min"
                minValue={1}
                onSave={(a) => this.props.onSave(a)}
                onExit={() => this.props.onExit()} />
        );
    }
}
